import ActiveService from "rapid/service.active";

export class CompaniesService extends ActiveService {
	/**
	 *
	 * @param $injector
	 * @param CONFIG
	 * @param $auth
	 */
	constructor($injector, CONFIG, $auth) {
		"ngInject";
		super($injector);
		this.CONFIG = CONFIG;
		this.$auth = $auth;
	}

	set(company) {
		this.cacheSet("company", company);
	}

	getCached(key) {
		return this.cacheGet(key ? key : "company");
	}

	fetch() {
		return this
			.get(this.$auth.getUser().company.url)
			.then(company => this.cacheSet("company", company));
	}

	// async $getCompanyProfiles () {
	// 	return this.activeGet("/api/company-profiles");
	// }

}


// WEBPACK FOOTER //
// ./sources/services/companies.js